

class InfiniteScrollController

    ### @ngInject ###
    constructor: ($q, $scope, $element, Page) ->
        [@q, @scope, @element] = arguments
        @scrollContainer = Page.element()
        @enableScrollEvent()
        @scope.$on '$destroy', @disableScrollEvent

    atBottom: =>
        scrollRect = @scrollContainer[0].getBoundingClientRect()
        elementRect = @element[0].getBoundingClientRect()
        return elementRect.bottom <= scrollRect.height

    enableScrollEvent: =>
        @scrollContainer.on('scroll', @scrollHandler)
        return

    disableScrollEvent: =>
        @scrollContainer.off('scroll', @scrollHandler);
        return

    scrollHandler: =>
        if not @atBottom() or not @hasMore or @waiting then return
        @waiting = true
        @scope.$applyAsync @triggerEvent
        return

    triggerEvent: =>
        @waiting = true
        result = @doScroll()
        return @q.when(result).then =>
            @waiting = false
            return 



infiniteScrollDirective = ->
    'ngInject'

    restrict: 'A'
    scope: doScroll: '&infiniteScroll', hasMore: '='
    controllerAs: 'ctrl'
    controller: InfiniteScrollController
    bindToController: true


module.directive('infiniteScroll', infiniteScrollDirective)
